var map = {
	"./cover_img.jpg": 1245,
	"./q1.jpg": 6392,
	"./q10.jpg": 948,
	"./q10_trivia.jpg": 6101,
	"./q1_trivia.jpg": 6571,
	"./q2.jpg": 8717,
	"./q2_trivia.jpg": 7205,
	"./q3.jpg": 2234,
	"./q3_trivia.jpg": 1038,
	"./q4.jpg": 3185,
	"./q4_trivia.jpg": 8307,
	"./q5.jpg": 7896,
	"./q5_trivia.jpg": 8862,
	"./q6.jpg": 8089,
	"./q6_trivia.jpg": 2782,
	"./q7.jpg": 7380,
	"./q7_trivia.jpg": 6388,
	"./q8.jpg": 3126,
	"./q8_trivia.jpg": 4155,
	"./q9.jpg": 7293,
	"./q9_trivia.jpg": 9690
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3929;